import { useState } from "react";
import toast from "react-hot-toast";
import { X } from "lucide-react";
import { useCreatePayrollRun } from "@/api/payroll";
import { getApiErrorMessage } from "@/api/client";

export default function CreatePayrollRunModal({ onClose }: { onClose: () => void }) {
  const createRun = useCreatePayrollRun();
  const [periodLabel, setPeriodLabel] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createRun.mutateAsync({ periodLabel, startDate, endDate });
      toast.success("Corrida de nómina generada correctamente.");
      onClose();
    } catch (error) {
      toast.error(getApiErrorMessage(error));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 px-4">
      <div className="card w-full max-w-sm p-6">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">Nueva corrida de nómina</h2>
          <button type="button" className="text-gray-400 hover:text-gray-600" onClick={onClose} aria-label="Cerrar">
            <X size={18} />
          </button>
        </div>
        <p className="mt-2 text-xs text-gray-500">
          Se generará una línea de liquidación por cada empleado activo, calculando automáticamente las deducciones de salud y pensión.
        </p>
        <form className="mt-4 space-y-3" onSubmit={handleSubmit}>
          <div>
            <label className="block text-sm font-medium text-gray-700">Periodo</label>
            <input
              className="input-field mt-1"
              placeholder="Ej. 2026-08"
              value={periodLabel}
              onChange={(e) => setPeriodLabel(e.target.value)}
              required
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">Desde</label>
              <input type="date" className="input-field mt-1" value={startDate} onChange={(e) => setStartDate(e.target.value)} required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Hasta</label>
              <input type="date" className="input-field mt-1" value={endDate} onChange={(e) => setEndDate(e.target.value)} required />
            </div>
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn-primary" disabled={createRun.isPending}>
              {createRun.isPending ? "Generando..." : "Generar corrida"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
